<div
  class="login-account gw-box-border gw-min-h-screen gw-min-w-0 gw-w-full gw-max-w-full gw-overflow-x-hidden gw-bg-background-base gw-flex gw-items-start md:gw-items-center gw-justify-center"
>
  <div
    class="gw-mx-auto gw-min-w-0 gw-w-full gw-max-w-[1600px] gw-px-4 gw-py-large sm:gw-px-6 lg:gw-px-8"
  >
    <div
      class="gw-grid gw-min-w-0 gw-w-full gw-grid-cols-1 gw-gap-0 lg:gw-grid-cols-12 lg:gw-gap-8 xl:gw-gap-10"
    >
      <!-- Left: grid cell is full width; inner stack stays max 640px centered on all breakpoints -->
      <div
        class="gw-col-span-1 gw-flex gw-min-w-0 gw-w-full gw-flex-col gw-justify-start lg:gw-justify-center"
        [ngClass]="{
          'lg:gw-col-span-6': hasOnboardingSidePanelImage,
          'lg:gw-col-span-12': !hasOnboardingSidePanelImage,
        }"
      >
        <div
          class="gw-mx-auto gw-flex gw-min-h-[480px] gw-min-w-0 gw-w-full gw-max-w-[640px] gw-shrink-0 gw-flex-col"
        >
          <div
            class="gw-mb-medium gw-flex gw-w-full gw-min-w-0 gw-justify-center gw-px-1"
          >
            <img
              [src]="style.logo"
              [alt]="'features.onboarding.shell.headerLogoAlt' | translate"
              class="gw-h-auto gw-max-h-12 gw-w-auto gw-max-w-full gw-object-contain"
            />
          </div>

          <div class="gw-mb-small">
            <gatewee-button
              variant="outline"
              size="s"
              [title]="'features.onboarding.shell.back' | translate"
              *ngIf="selectedStepIndex > 0 && !isSubmitting"
              (clicked)="goPrevious()"
              [iconName]="'@phi.arrow-left'"
            ></gatewee-button>
          </div>

          <div
            class="gw-flex gw-min-w-0 gw-flex-1 gw-flex-col gw-overflow-hidden gw-rounded-2xl gw-border gw-border-solid gw-border-transparent gw-bg-background-elevation-1 gw-p-small md:gw-p-x-large gw-shadow-md"
          >
            <div
              *ngIf="isLoading"
              class="gw-flex gw-min-h-[320px] gw-flex-col gw-items-center gw-justify-center gw-gap-small gw-text-center gw-text-sm gw-text-text-secondary"
            >
              <span>{{ 'common.actions.loading' | translate }}</span>
            </div>

            <div
              *ngIf="loadError && !isLoading"
              class="gw-flex gw-min-h-[320px] gw-flex-col gw-items-center gw-justify-center gw-gap-medium gw-text-center"
            >
              <p class="gw-text-sm gw-text-text-secondary">
                {{ 'features.onboarding.toast.submitError' | translate }}
              </p>
              <gatewee-button
                variant="primary"
                size="s"
                [title]="'common.selectAsync.retry' | translate"
                (clicked)="retryFetchExistingData()"
              ></gatewee-button>
            </div>

            <ng-container *ngIf="!isLoading && !loadError">
              <div
                class="gw-mb-small gw-flex gw-min-w-0 gw-w-full gw-flex-col gw-gap-x-small"
                *ngIf="steps.length"
              >
                <span
                  class="gw-break-words gw-text-2xl gw-font-semibold gw-text-text-primary"
                >
                  {{ activeStepTitle() }}
                </span>

                <span class="gw-break-words gw-text-sm gw-text-text-secondary">
                  {{ activeStepDescription() }}
                </span>
              </div>

              <div class="gw-mb-x-small gw-min-w-0 gw-w-full">
                <app-progressbar-stepper
                  [steps]="steps.length"
                  [currentStep]="selectedStepIndex + 1"
                >
                </app-progressbar-stepper>
              </div>

              <div
                class="gw-mb-medium gw-text-center gw-text-xs gw-text-text-tertiary"
                *ngIf="steps.length"
              >
                {{ selectedStepIndex + 1 }} / {{ steps.length }}
              </div>

              <ng-container *ngIf="steps[selectedStepIndex] as step">
                <div class="gw-min-w-0 gw-w-full">
                  <ng-container
                    *ngComponentOutlet="step.component; inputs: step.inputs"
                  >
                  </ng-container>
                </div>

                <div class="gw-mt-medium gw-flex gw-flex-col gw-gap-small">
                  <gatewee-button
                    *ngIf="selectedStepIndex < steps.length - 1"
                    [title]="'features.onboarding.shell.next' | translate"
                    variant="primary"
                    class="gw-w-full"
                    (clicked)="nextStep(selectedStepIndex + 1)"
                    [disabled]="isCurrentStepInvalid() || isSubmitting"
                  ></gatewee-button>

                  <gatewee-button
                    *ngIf="selectedStepIndex === steps.length - 1"
                    [title]="'features.onboarding.shell.finish' | translate"
                    variant="primary"
                    class="gw-w-full"
                    (clicked)="submit()"
                    [disabled]="isFinishDisabled()"
                  ></gatewee-button>
                </div>
              </ng-container>

              <div
                class="gw-mt-medium gw-text-center gw-text-sm gw-text-text-secondary"
              >
                {{ 'features.onboarding.shell.alreadyHaveAccount' | translate }}
                <a
                  href="/login"
                  class="gw-font-medium gw-text-text-action hover:gw-underline"
                >
                  {{ 'features.onboarding.shell.login' | translate }}
                </a>
              </div>

              <div
                *ngIf="hasSupportChannels"
                class="gw-mt-medium gw-rounded-lg gw-bg-background-neutral-1 gw-p-small gw-text-center gw-text-xs gw-text-text-secondary"
              >
                <p class="gw-mb-2 gw-leading-snug">
                  {{ 'features.onboarding.shell.helpIntro' | translate }}
                </p>
                <div
                  class="gw-flex gw-flex-wrap gw-items-center gw-justify-center gw-gap-x-medium gw-gap-y-x-small"
                >
                  <a
                    *ngIf="supportWhatsappHref"
                    [href]="supportWhatsappHref"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="gw-inline-flex gw-items-center gw-gap-x-small gw-font-medium gw-text-text-action hover:gw-underline"
                    [attr.aria-label]="
                      'features.onboarding.shell.helpWhatsappAria' | translate
                    "
                  >
                    <gatewee-icon
                      icon="@phi.chat-circle-text"
                      size="14px"
                      class="gw-shrink-0"
                    ></gatewee-icon>
                    {{ 'features.onboarding.shell.helpWhatsapp' | translate }}
                  </a>
                  <a
                    *ngIf="supportMailtoHref"
                    [href]="supportMailtoHref"
                    class="gw-inline-flex gw-items-center gw-gap-x-small gw-font-medium gw-text-text-action hover:gw-underline"
                    [attr.aria-label]="
                      'features.onboarding.shell.helpEmailAria' | translate
                    "
                  >
                    <gatewee-icon
                      icon="@phi.envelope-simple"
                      size="14px"
                      class="gw-shrink-0"
                    ></gatewee-icon>
                    {{ 'features.onboarding.shell.helpEmail' | translate }}
                  </a>
                </div>
              </div>

              <div
                class="gw-mt-medium gw-flex gw-items-center gw-justify-center gw-gap-x-small gw-text-center gw-text-xs gw-text-text-tertiary"
              >
                <gatewee-icon
                  icon="@phi.lock"
                  size="14px"
                  class="gw-shrink-0"
                  aria-hidden="true"
                ></gatewee-icon>
                <span>{{
                  'features.onboarding.shell.dataEncrypted' | translate
                }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Right (only when side panel image is configured) -->
      <div
        *ngIf="hasOnboardingSidePanelImage"
        class="gw-hidden lg:gw-col-span-6 lg:gw-block"
      >
        <div
          class="sidePanel gw-relative gw-h-full gw-w-full gw-overflow-hidden gw-rounded-[32px] gw-p-6 gw-text-white lg:gw-min-h-[720px] xl:gw-p-8"
        >
          <!-- Photo full strength → accent tint (blend) → bottom scrim for copy -->
          <div
            class="sidePanel-image"
            [ngStyle]="{
              'background-image':
                'url(' + pageSettings.onboarding.sidePanel.backgroundImage + ')',
            }"
            aria-hidden="true"
          ></div>
          <div class="sidePanel-tint" aria-hidden="true"></div>
          <div class="sidePanel-scrim" aria-hidden="true"></div>

          <div class="gw-absolute gw-left-0 gw-top-0 gw-z-10 gw-p-6 xl:gw-p-8">
            <p
              class="header-title gw-text-white"
              *ngIf="pageSettings.onboarding.sidePanel.headerTitle"
            >
              {{ pageSettings.onboarding.sidePanel.headerTitle }}
            </p>

            <img
              class="header-logo gw-max-w-[150px]"
              *ngIf="!pageSettings.onboarding.sidePanel.headerTitle"
              [src]="style.logoWhite || style.logo"
              [alt]="'features.onboarding.shell.headerLogoAlt' | translate"
            />
          </div>

          <div
            class="gw-absolute gw-bottom-0 gw-left-0 gw-z-10 gw-p-6 xl:gw-p-8"
          >
            <h1
              class="footer-title gw-text-white"
              *ngIf="pageSettings.onboarding.sidePanel.footerTitle"
            >
              {{ pageSettings.onboarding.sidePanel.footerTitle }}
            </h1>

            <p
              class="footer-description gw-text-white"
              *ngIf="pageSettings.onboarding.sidePanel.footerDescription"
            >
              {{ pageSettings.onboarding.sidePanel.footerDescription }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
